import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/SupabaseAuthContext';
import { is2FAEnabled, is2FAVerified } from '../utils/2fa';
import AdminSecurityWrapper from './AdminSecurityWrapper';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Đang tải...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/vmon-admin/login" replace />;
  }

  // If 2FA is enabled but not verified in this session, redirect to login
  if (is2FAEnabled() && !is2FAVerified()) {
    return <Navigate to="/vmon-admin/login" replace />;
  }

  return <AdminSecurityWrapper>{children}</AdminSecurityWrapper>;
};

export default ProtectedRoute;